import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { post, put, upload } from "../../../helpers/api_helper";
import { toast } from "react-toastify";
import ProgressBar from "../../../components/ProgressBar";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Utils from "../../Utility";

// actions

import Table from "./Table";
import Loader from "../../../components/Loader";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import moment from "moment";
import { useHistory } from "react-router-dom";
const Property = (props) => {
  const { user } = props;
  const history = useHistory();
  const [isAddForm, setIsAddForm] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [currentData, setCurrentData] = useState(null);
  const [currentData1, setCurrentData1] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleId, setSingleId] = useState(null);
  const [file, setFile] = useState(null);
  const [dateType, setDateType] = useState(true);
  const [newsPannel, setNewsPannel] = useState(false);
  const [progress, setProgress] = useState({ visible: false, value: 0 });
  const formRef = useRef(null);
  // console.log("add Job page props", props, typeof moment(currentData?.valid_till).format('DD-MM-YYYY') ,moment(currentData?.valid_till).format('DD-MM-YYYY'));

  const onChangeFile = (event) => {
    console.log("File changed:", event.target.files[0]);
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    if (props?.location?.state) {
      setCurrentData(props?.location?.state?.row);
      if (props?.location?.state?.row?.pdf)
        setFile(props?.location?.state?.row?.pdf);
      setDateType(false);
    }
  }, [props?.location?.state]);

  const onProgress = (progress) => {
    setProgress({ visible: true, value: progress });
  };

  const handleValidSubmit = async (e, v) => {
    console.log("pdf file", file);
    let pdf = file;
    if (typeof file == "object") {
      let type = file.name.split(".");
      type = type[type.length - 1];
      if (type != "pdf") {
        toast.error("Select a valid pdf file!");
        return;
      }
      try {
        const imageRes = await upload("pdf", file, "pdf", onProgress);
        console.log("upload response", imageRes);
        if (imageRes?.statusCode == 200) {
          pdf = imageRes?.data;
        } else {
          toast.error(imageRes?.error || "Failed to upload PDF!");
          setProgress({ visible: false, value: 0 });
          return;
        }
      } catch (uploadErr) {
        console.error("Upload error:", uploadErr);
        toast.error(typeof uploadErr === "string" ? uploadErr : "Failed to upload PDF!");
        setProgress({ visible: false, value: 0 });
        return;
      }
      setProgress({ visible: false, value: 0 });
    }
    setLoading(true);
    let body = {
      ...v,
      pdf: pdf,
      news_panel: newsPannel,
      token: user?.token,
    };
    console.log("Form Submitted", body);

    const resetFormState = () => {
      if (formRef.current) {
        formRef.current.reset();
      }
      setFile(null);
      setCurrentData(null);
      setNewsPannel(false);
      setProgress({ visible: false, value: 0 });
    };

    if (currentData) {
      body = { ...body, jobId: currentData?._id };
      put("/job", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            resetFormState();
            history.push("/view-job");
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err?.message || err);
          setLoading(false);
        });
    } else {
      post("/job", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            resetFormState();
            history.push("/view-job");
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err?.message || err);
          setLoading(false);
        });
    }
  };

  const disPlayNews = (e) => {
    console.log("add news panel", e?.target?.checked);
    setNewsPannel(e.target.checked);
  };
  console.log("currentData =>", currentData);
  return (
    <>
      <div className="page-content">
        <Loader visible={loading} />
        <ProgressBar visible={progress?.visible} progress={progress.value} />
        {/* Render Breadcrumb */}
        <Breadcrumb
          title={Utils.projectName}
          breadcrumbItem={currentData ? `Update Job!` : `Add New Job`}
        />

        <div className="main-box-form main_box_form_all">
          <div className="table_top_header">
            <CardTitle className="h4">
              <i class="mdi mdi-pencil"></i> Add job{" "}
            </CardTitle>
          </div>
          <Card style={{ borderRadius: "0" }}>
            <CardBody>
              <AvForm
                ref={formRef}
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  console.log("Form data submitted:", v);
                  handleValidSubmit(e, v, "bank");
                }}
              >
                <Row>
                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      {file ? (
                        <>
                          <CardTitle>PDF</CardTitle>
                          <div
                            style={{
                              flexDirection: "row",
                              position: "relative",
                              cursor: "pointer",
                              marginTop: 20,
                              width: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <>
                              <div className="pdf-container">
                                <img
                                  src={require("../../../assets/images/imgpdf.jpg")}
                                  style={{ width: 100, height: "auto" }}
                                />
                                <i
                                  className="mdi mdi-close"
                                  style={{
                                    color: "white",
                                    backgroundColor: Utils.themeColor,
                                    fontSize: 20,
                                    position: "absolute",
                                    top: -16,
                                    right: 112,
                                    borderRadius: 15,
                                    width: 30,
                                    height: 30,
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    setFile(null);
                                    if (currentData)
                                      setCurrentData({
                                        ...currentData,
                                        image: undefined,
                                      });
                                  }}
                                />
                              </div>
                            </>
                          </div>
                        </>
                      ) : (
                        <AvField
                          name="fileInput"
                          label="PDF File"
                          className="form-control"
                          placeholder="Upload PDF"
                          type="file"
                          onChange={(e) => onChangeFile(e)}
                          required
                          multiple={false}
                          // ref={imageInput}
                          accept=".pdf"
                          // value={currentData?.logo}
                        />
                      )}
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="plant"
                        label="Select Plant *"
                        className="form-control"
                        placeholder="Enter live session url"
                        type="select"
                        required
                        value={currentData?.plant}
                      >
                        <option value="">Select an option</option>
                        <option value="Corporate Office">
                          Corporate Office
                        </option>
                        <option value="Gurgaon Plant">Gurgaon Plant</option>
                        <option value="Rishikesh Plant">Rishikesh Plant</option>
                        <option value="Chennai Plant">
                          IDPL(TN) Chennai Plant
                        </option>
                        <option value="Bhubaneswar Plant">
                          ODCL Bhubaneswar
                        </option>
                        <option value="Hyderabad Plant">Hyderabad Plant</option>
                      </AvField>
                    </div>
                  </Col>

                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="title"
                        label="Title *"
                        className="form-control"
                        placeholder="Example :Sealed Jobs are invited for supply....."
                        type="text"
                        required
                        value={currentData?.title}
                      />
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="form-group mb-4">
                      <AvField
                        name="valid_till"
                        label={"Valid Till :*"}
                        value={
                          currentData
                            ? moment(currentData?.valid_till).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        className="form-control"
                        type="date"
                        required
                      />
                    </div>
                  </Col>
                  <br />
                  <Col lg={12} md={12}>
                    <div className="form-group check_box_all_form ">
                      <input
                        label="Display to news panel"
                        name="news_panel"
                        type="checkbox"
                        onClick={disPlayNews}
                        checked={currentData?.news_panel}
                      />
                      <label>Display to news panel</label>
                    </div>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Row>
                    {currentData && (
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor1,
                            border: "none",
                          }}
                          onClick={() => {
                            history.goBack();
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                    )}
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{
                          backgroundColor: Utils.themeColor,
                          border: "none",
                        }}
                      >
                        {currentData ? "Update" : "Submit"}
                      </button>
                    </Col>
                  </Row>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

Property.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { user } = state.Profile;
  console.log("user mat", user);
  const { company } = state.Company;
  return { user, company };
};

export default withRouter(connect(mapStatetoProps, {})(Property));
